export type DiagnosticLabelKey = "diag.label.zone" | "diag.label.junction" | "diag.label.component" | "diag.label.load";

/** A deferred generic label, still composable inside a string variable/list.
 * Real component names remain plain text; only these four internal labels are
 * resolved when a renderer supplies its locale. No locale enters engine state. */
export function diagnosticLabel(key: DiagnosticLabelKey): string {
  return `\uE000crimp:${key}\uE001`;
}

export function resolveDiagnosticLabels(value: string, lookup: (key: DiagnosticLabelKey) => string): string {
  return value.replace(/\uE000crimp:(diag\.label\.(?:zone|junction|component|load))\uE001/g,
    (_match, key: DiagnosticLabelKey) => lookup(key));
}
